/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC }     from 'react';
import { styles } from './styles';
import { Input }  from '~/components/input';

export const PersonalForm: FC = () => (
  <div css={styles.container}>
    <div css={styles.form}>
      <div css={styles.columns}>
        <div css={styles.row}>
          <Input name="firstName" label="Vorname" />
        </div>
        <div css={styles.row}>
          <Input name="lastName" label="Nachname" />
        </div>
      </div>
      <div css={styles.columns}>
        <Input name="email" label="E-Mail" type="email" />
      </div>
      <div css={styles.columns}>
        <Input name="phone" label="Telefonnummer" type="phone" />
      </div>
    </div>
  </div>
);